module.exports = __webpack_public_path__ + "img/小资讯2.81204739.png";